import React, { useState } from "react";
import { List, ListItem, ListItemText, Tooltip, Typography, Box } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import helpPageCards from "./HelpContent";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
  SidebarContainer,
  SidebarButton,
  CollapsedSidebarContainer,
} from "./Help.styled";

export const CommonQuestionSidebar: React.FC = () => {
  const location = useLocation();
  const [open, setOpen] = useState<boolean>(true);
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  const isActive = (path: string) => location.pathname === path;

  const categories = Array.from(new Set(helpPageCards.map(card => card.category)));
  const categorizedCards = categories.reduce((acc, category) => {
    acc[category] = helpPageCards.filter(card => card.category === category);
    return acc;
  }, {} as Record<string, typeof helpPageCards>);

  return (
    <>
      {open ? (
        <SidebarContainer>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Quick Links
            </Typography>
            <SidebarButton onClick={() => setOpen(!open)}>
              <KeyboardArrowLeftIcon />
            </SidebarButton>
          </Box>
          <List component="nav" aria-labelledby="nested-list-subheader">
            {Object.entries(categorizedCards).map(([category, cards]) => (
              <Box key={category} sx={{ mb: 2 }}>
                <Typography 
                  variant="subtitle2" 
                  sx={{ 
                    color: 'text.secondary',
                    fontWeight: 600,
                    px: 2,
                    mb: 1
                  }}
                >
                  {category}
                </Typography>
                {cards.map((card, index) => (
                  <Tooltip title={card.title} key={index} placement="left">
                    <ListItem
                      button
                      component={Link}
                      to={card.path}
                      onMouseEnter={() => setHoveredItem(card.path)}
                      onMouseLeave={() => setHoveredItem(null)}
                      sx={{
                        background:
                          isActive(card.path) || hoveredItem === card.path
                            ? "linear-gradient(135deg, #EEF2FF, #E0E7FF)"
                            : "transparent",
                        borderRadius: "8px",
                        transition: "all 0.3s ease",
                        transform:
                          isActive(card.path) || hoveredItem === card.path
                            ? "translateX(-4px)"
                            : "none",
                        mb: 0.5,
                        '&:hover': {
                          background: "linear-gradient(135deg, #EEF2FF, #E0E7FF)",
                        }
                      }}
                    >
                      <ListItemText
                        primary={card.title}
                        sx={{
                          color:
                            isActive(card.path) || hoveredItem === card.path
                              ? "#4F46E5"
                              : "text.primary",
                          fontWeight: isActive(card.path) ? 600 : 400,
                          '& .MuiListItemText-primary': {
                            fontSize: '0.875rem',
                            lineHeight: 1.5,
                          }
                        }}
                      />
                    </ListItem>
                  </Tooltip>
                ))}
              </Box>
            ))}
          </List>
        </SidebarContainer>
      ) : (
        <CollapsedSidebarContainer>
          <SidebarButton onClick={() => setOpen(!open)}>
            <KeyboardArrowRightIcon />
          </SidebarButton>
        </CollapsedSidebarContainer>
      )}
    </>
  );
};

export default CommonQuestionSidebar;
